import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RaisedButton, CircularProgress, Snackbar } from 'material-ui';
import { parse } from 'qs';
import { reduxForm } from 'redux-form';
import { institutionField, institutionPreviewField } from './InstitutionField'
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import Error from '../containers/Error'

class InstitutionUpdateForm extends Component {
  componentWillMount = () => {
    const query = parse(this.props.location.search.substr(1));
    this.props.institutionActions.get(query.id);
  }

  attribute = (key, val) => {
    return new CognitoUserAttribute({
      "Name": key,
      "Value": val,
    });
  }

  // プレビュー On/Off.
  handlePreview = (on) => {
    if (on) {
      // 入力チェックして正しくないときは無視.
      if (this.props.invalid) {
        return;
      }
    }

    this.props.institutionActions.preview(on);
  }

  // 更新.
  handleSubmit = () => {
    // アカウントIDは深くにある.
    const institutionSub = this.props.institution.institution.institution.institution_sub;
    // institution_id
    const institution_id = this.props.institution.institution.institution.institution_id;
    const enabled = this.props.institutionUpdateForm.enabled;

    // updateDynamoDB と Enable/Disableの処理.
    this.props.institutionActions.updateDynamoDBAndEnable(institutionSub, {
      "institution_name": this.props.institutionUpdateForm.institution_name,
      "institution_name_kana": this.props.institutionUpdateForm.institution_name_kana,
      "company_name": this.props.institutionUpdateForm.company_name,
      "company_name_kana": this.props.institutionUpdateForm.company_name_kana,
      "institution_phone": this.props.institutionUpdateForm.institution_phone,
      "institution_email": this.props.institutionUpdateForm.institution_email,
      "post_code": this.props.institutionUpdateForm.post_code,
      "address": this.props.institutionUpdateForm.address,
      "fax": this.props.institutionUpdateForm.fax,
      "Administrator": this.props.institutionUpdateForm.Administrator,
      "ContactPerson": this.props.institutionUpdateForm.ContactPerson,
      "iPadCode": this.props.institutionUpdateForm.iPadCode,
      "enabled": this.props.institutionUpdateForm.enabled,
    }, institution_id, enabled);
  }

  /**
   * API通信中かどうか（ボタン連打防止の為）.
   *
   * @returns
   * @memberof InstitutionUpdateForm
   */
  isAPICalling() {
    return this.props.institution.DynamoDBUpdating || this.props.institution.Enabling || this.props.institution.Disabling;
  }

  render() {
    const institutionInfo = this.props.institution.institution;

    // ローディング.
    if (institutionInfo === null) {
      return (
        <div style={{position: 'relative', margin: 'auto', textAlign: 'center'}}>
          <CircularProgress size={200} thickness={15} />
        </div>
      );
    }

    const wellStyles = {
      formStyle: {maxWidth: 800, margin: '0 auto 10px'},
      buttonStyle: {margin: 12, width:'100px', marginLeft: '340px'},
      buttonLabelStyle: {fontSize: '17px'},
      leftButtonStyle: {margin: 12, marginLeft: '300px'},
      resultButtonStyle: {margin: 12, marginLeft: '250px'},
    };


    const enabled = this.props.institutionUpdateForm.enabled;
    // プレビュー時.
    if (this.props.institution.Previewing) {
      return (
        <form style={wellStyles.formStyle}>
          {this.isAPICalling() ? institutionPreviewField(enabled, true) : institutionPreviewField(enabled, false)}
          <RaisedButton
            type="button"
            label="戻る"
            disabled={this.isAPICalling()}
            style={wellStyles.leftButtonStyle}
            labelStyle={wellStyles.buttonLabelStyle}
            onClick={() => this.handlePreview(false)}
          />
          <RaisedButton
            type="button"
            label="更新する"
            primary={true} 
            disabled={this.isAPICalling()}
            style={{margin: 12}}
            labelStyle={wellStyles.buttonLabelStyle}
            onClick={() => this.handleSubmit()}
          />
          <br /><br /><br />
        </form>
      )
    } else {
      // 結果時.
      if (this.props.institution.DynamoDBUpdated === true
        // エラー時はfalse.
        && this.props.institution.result === true) {
        // 一覧画面.
        let returnUrl = "/institutions/list";

        return (
          <form style={wellStyles.formStyle}>
            {enabled ? institutionPreviewField(true, true) : institutionPreviewField(false, true)}
            <div>施設登録情報を更新しました。</div>
            <RaisedButton
              type="button"
              label="このページを印刷"
              style={wellStyles.resultButtonStyle}
              labelStyle={wellStyles.buttonLabelStyle}
              onClick={() => {window.print();}}
            />
            <RaisedButton
              type="button"
              label="施設一覧へ"
              primary={true} 
              style={{margin: 12}}
              labelStyle={wellStyles.buttonLabelStyle}
              href={returnUrl}
            />
            <br /><br /><br />
            <Snackbar
              message={'更新されました'}
              open={true}
              autoHideDuration={4000}
              bodyStyle={{ backgroundColor: '#DAEDD2'}}
              contentStyle={{ color: '#356B35' }}
            />
          </form>
        );
      } else {
        // デフォルト.
        return (
          <form style={wellStyles.formStyle}>
            {enabled ? institutionField(true) : institutionField(false)}
            <RaisedButton
              type="button"
              label="更新確認"
              primary={true}
              disabled={this.props.institution.DynamoDBUpdating}
              style={wellStyles.buttonStyle}
              labelStyle={wellStyles.buttonLabelStyle}
              onClick={() => this.handlePreview(true)}
            />
            <br /><br /><br />
            {
              // API実行されている.
              this.props.institution.DynamoDBUpdated === true && this.props.institution.err ?
                <Error title={'施設情報更新時にエラーが発生しました'} message={this.props.institution.err.message} /> :
                (null)
            }
          </form>
        );
      }
    }
  }
}

InstitutionUpdateForm.propTypes = {
  institution: PropTypes.object.isRequired,
  institutionActions: PropTypes.object.isRequired,
  institutionUpdateForm: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'institutionUpdateForm',
  // 各プロパティはreducer
})(InstitutionUpdateForm);



// WEBPACK FOOTER //
// ./src/components/InstitutionUpdateForm.js